import React from 'react';
import cn from 'classnames';
import { Box, BoxProps, TextField, Theme, withStyles } from '@material-ui/core';

export const RangePickerWrapperBox = withStyles(() => ({
  root: {
    width: '100%',
    '& .MuiPickersDateRangePickerInput-root': {
      width: '100%',
    },
  },
}))(Box);

export const StyledTextField = withStyles(() => ({
  root: {},
}))(TextField);

interface FieldBoxProps extends BoxProps {
  isLast?: boolean;
}

export const FieldBox = withStyles(({ breakpoints, spacing }: Theme) => ({
  root: {
    width: '100%',
    marginBottom: spacing(2),
    [breakpoints.up('sm')]: {
      marginBottom: 0,
    },
    '&.isLast': {
      marginBottom: 0,
    },
  },
}))(({ isLast, ...otherProps }: FieldBoxProps) => (
  <Box {...otherProps} className={cn({ isLast })} />
));
